var map = {
	"./coupon.routes.js": 92047,
	"./integral.routes.js": 76837,
	"./invoice.routes.js": 4904,
	"./kfc.routes.js": 76471,
	"./localProduct.routes.js": 90283,
	"./mall.routes.js": 17671,
	"./mc.routes.js": 53085,
	"./merchant.routes.js": 26473,
	"./movie.routes.js": 70029,
	"./pointsmall.routes.js": 5154,
	"./ship.routes.js": 66155,
	"./travel.routes.js": 44081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68951;